import { IsBoolean, IsDateString, IsMimeType, IsNumberString, IsObject, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class ImageDimensionsDto {
	@IsNumberString()
	@IsOptional()
	width?: string;

	@IsNumberString()
	@IsOptional()
	height?: string;
}


export class AssetDto {
	@IsUUID()
	id: string;

	@IsString()
	title: string;

	@IsString()
	type: string;

	@IsString()
	assetPath: string;

	// Original-source URL for connectors that substitute a renderable rendition into assetPath
	// (e.g., Brandshare uses the 1200px JPEG preview as assetPath for tif/psd/etc., and surfaces
	// the original download URL here so ingestion paths can still reach the source file).
	@IsString()
	@IsOptional()
	originalAssetPath?: string;

	@IsString()
	@IsOptional()
	businessId: string | null;

	@IsUUID()
	@IsOptional()
	projectId: string | null;

	@IsString()
	provider: string;

	@IsUUID()
	siteId: string;

	@IsString()
	@IsDateString()
	created: string;

	@IsString()
	@IsOptional()
	description: string | null;

	@Type(() => ImageDimensionsDto)
	@ValidateNested()
	@IsOptional()
	dimensions?: ImageDimensionsDto;

	@IsMimeType()
	mimeType: string;

	@IsObject()
	@IsOptional()
	metadata?: Record<string, any>;

	@IsBoolean()
	@IsOptional()
	isRemote?: boolean;

	@IsString()
	@IsOptional()
	localUrl?: string;

	@IsOptional()
	mediaType?: string;

	@IsOptional()
	externalIds: Record<string, string>;

	@IsBoolean()
	@IsOptional()
	delete?: boolean;

	// Used optionally to apply values to other template areas.
	@IsOptional()
	mappings?: any; // TODO: Figure out how to type this without breaking API: CustomizationOptionMappingDto

	// Assets can have other stuff that comes from other sources.
	[key: string]: any;

	public static toReceiptMarkdown(asset: AssetDto, includeDevInfo = false) {
		let mdString: string = '';
		if (asset?.title) {
			mdString += `__Title:__ ${asset.title}<br>`;
		}
		if (asset?.description) {
			mdString += `__Description:__ ${asset.description}<br>`;
		}
		if (asset?.dimensions?.width && asset?.dimensions?.height) {
			mdString += `__Dimensions:__ ${asset.dimensions.width + 'x' + asset.dimensions.height}<br>`;
		}
		if (asset?.assetPath) {
			mdString += `__Path:__ ${asset.assetPath}<br>`;
		}

		if (includeDevInfo) {
			if (asset?.mimeType) {
				mdString += `__Mime Type:__ ${asset.mimeType}<br>`;
			}
			if (asset?.provider) {
				mdString += `__Provider:__ ${asset.provider}<br>`;
			}
		}
		return mdString;
	}
}

export const AssetDtoItemDef: AssetDto = {
	id: '',
	title: '',
	type: '',
	assetPath: '',
	originalAssetPath: undefined,
	businessId: null,
	projectId: null,
	provider: '',
	siteId: '',
	created: '',
	description: null,
	dimensions: {
		width: '',
		height: ''
	},
	mimeType: '',
	metadata: {},
	isRemote: false,
	localUrl: undefined,
	mediaType: '',
	externalIds: {},
	delete: false
};
